var gql = require("@apollo/client").gql;

const MUTATE_INCREMENT_LIKE_DISLIKE = gql`
    mutation(
        $street_id: Int
        $address_id: Int
        $like: Boolean
        $dislike: Boolean
    ) {
        incrementLikeDislike(
            street_id: $street_id
            address_id: $address_id
            like: $like
            dislike: $dislike
        )
    }
`;

export default MUTATE_INCREMENT_LIKE_DISLIKE;
